import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import {UserAgentUtils} from "../../utils/useragent";
import Toast from "./Toast";
import {ReactComponent as ErrorIcon} from "assets/img/error.svg"
import {FormattedMessage} from "react-intl";

WrongScanToast.PropsType = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired
}

function WrongScanToast({open, handlClose}) {
    const [isMobile, setIsMobile] = useState(UserAgentUtils.isMobile())

    return (
        <Toast
            title={<FormattedMessage id={"wms.scanToast.wrongScan.title"}/>}
            subtitle={<FormattedMessage id={"wms.scanToast.wrongScan.subtitle"}/>}
            icon={<ErrorIcon/>}
            open={open}
            handleClose={handlClose}
            isDesktop={!isMobile}
        />
    );
}

export default WrongScanToast;